<template>
    <div class="main">
        <!-- channel banner -->
        <div class="cbanner">
            <img src="../../assets/images/banner_ucenter.jpg" />
            <div class="btext">
                <h3>个人信息</h3>
                <p>最低投资成本，最好的安全保证，专业互联网借贷信息中介平台</p>
            </div>
        </div><!-- channel banner END-->
        <div class="main_inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <span class="btitle">当前位置：</span>
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>用户中心</el-breadcrumb-item>
                <el-breadcrumb-item>个人信息</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row>
                <el-col :span="5" class="leftside">
                    <el-menu
                            default-active="1"
                            class="el-menu-vertical-demo"
                    >
                        <router-link :to="{ path: '/personalInformation' }">
                            <el-menu-item index="1"><span slot="title" >个人信息</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/passwordEdit'}">
                            <el-menu-item index="2"><span slot="title">修改密码</span></el-menu-item>
                        </router-link>
                        <router-link :to="{ path: '/myBorrow' }">
                            <el-menu-item index="3"><span slot="title">我的借贷</span></el-menu-item>
                        </router-link>
                    </el-menu>
                </el-col>
                <el-col :span="19">
                    <div class="con_right">
                        <div class="con">
                            <el-form ref="viewForm" :model="viewForm"  label-width="60px" class="el-form-self">

                                <el-row>
                                    <el-col>
                                        <el-form-item label="昵称:" prop="username">
                                            <div class="view-text">{{viewForm.username}}</div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col>
                                <el-form-item label="性别:" prop="sex">
                                    <div class="view-text">{{viewForm.sex==1?'男':viewForm.sex==2?'女':'未知'}}</div>
                                </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col>
                                <el-form-item label="年龄:" prop="age">
                                    <div class="view-text">{{viewForm.age}}</div>
                                </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col>
                                        <el-form-item label="学历:" prop="education">
                                            <div class="view-text">{{viewForm.education}}</div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-row>
                                    <el-col>
                                        <el-form-item label="手机号:" prop="phoneNumber">
                                            <div class="view-text">{{viewForm.phoneNumber}}</div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-row>
                                    <el-col>
                                        <el-form-item label="邮箱:" prop="email">
                                            <div class="view-text">{{viewForm.email}}</div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col>
                                        <el-form-item label="部门:" prop="email" v-if="this.viewForm.type=='1'">
                                            <div class="view-text">{{viewForm.department}}</div>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col>
                                        <el-form-item label="二维码:" prop="quickMark" v-if="this.viewForm.type=='1'">
                                            <img id="quickMark" :src="'data:image/png;base64,'+viewForm.quickMark" />
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row class="form-buttons">
                                    <el-form-item class="el-form-item-self">
                                        <el-button type="primary" @click="getPersonalInformationEditById">修改</el-button>
                                    </el-form-item>
                                </el-row>

                            </el-form>
                        </div>
                    </div>
                </el-col>
            </el-row>


            <el-dialog width="640px" title="修改个人信息" :visible.sync="dialogFormVisible" top="22vh" center>
                <el-form ref="editForm" :model="editForm" :rules="userRules" label-width="100px" class="el-form-self">

                    <el-row>
                        <el-col>
                            <el-form-item label="昵称:" prop="username">
                                <el-input  v-model="editForm.username"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="性别:" prop="sex">
                                <el-radio-group v-model="editForm.sex" class="el-input">
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="2">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="年龄:" prop="age">
                                <el-input v-model="editForm.age"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="学历:" prop="education">
                                <el-select v-model="editForm.education" class="el-select-big">
                                    <el-option
                                            v-for="item in educationArray"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="手机号:" prop="phoneNumber">
                                <el-input v-model="editForm.phoneNumber"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item label="邮箱:" prop="email">
                                <el-input v-model="editForm.email"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="personalInformationEdit">修改</el-button>
                </span>
            </el-dialog>

        </div>
    </div>
</template>
<script>
    import {reqGetDictionaryListByCode} from '../../api/system-api';
    import  {reqWebUserOne,reqWebUserEdit} from "../../api/webUser-api"
    import {downloadFileURL} from '../../api/intentionManagement-api'
    export default {
        data(){
            var checkAge = (rule, value, callback) => {
                var reg=/^[0-9]+.?[0-9]*$/;
                if (!value) {
                    return callback(new Error('年龄不能为空'));
                }
                if (!reg.test(value)) {
                    callback(new Error('请输入数字值'));
                } else if (value.toString().length > rule.length||value.toString().length<rule.length) {
                    callback(new Error('年龄必须为' + rule.length+'个字符'));
                } else{
                    if (value < 18) {
                        callback(new Error('必须年满18岁'));
                    } else {
                        callback();
                    }
                }
            };
            return{
                dialogFormVisible:false,
                educationArray:[],
                viewForm:{
                    id:'',
                    username:'',
                    sex:'',
                    age:'',
                    education:'',
                    phoneNumber:'',
                    email:'',
                    department:'',
                    quickMark:'',
                    type:'',

                },
                editForm:{
                    id:'',
                    username:'',
                    sex:'',
                    age:'',
                    education:'',
                    phoneNumber:'',
                    email:'',
                },
                userRules: {
                    username: [
                        {required: true, message: '请输入昵称', trigger: 'blur'},
                        {min: 1, max: 15, message: '昵称不能超过15个字符 ', trigger: 'blur'},
                        {pattern: /^[^ ]+[\s\S]*[^ ]+$/, message:'昵称前后不能有空格',trigger: 'blur'},
                    ],
                    sex: [
                        {required: true, trigger: 'change'},
                    ],
                    age: [
                        {required: true,validator: checkAge, trigger: 'blur',length:'2'},
                    ],
                    education: [
                        {required: true, message: '请选择学历'}
                    ],
                    phoneNumber: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: /^1[3|4|5|7|8|9][0-9]{9}$/, message:'请输入正确的手机号',trigger: 'blur'},
                    ],
                    email : [
                        { message: '请输入邮箱', trigger: 'blur'},
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
                    ],
                },
            }

        },
        methods:{

            //个人信息页面
            getPersonalInformation() {
                var id = window.sessionStorage.getItem('Authorization');
                reqWebUserOne({id: id}).then((res) => {
                    if (res.data.code === 1) {
                        this.viewForm= Object.assign({}, res.data.data);
                      this.$store.dispatch('user_type',res.data.data.type);
                        if( this.viewForm.department){
                            var that=this;
                            let para={code:'department'};
                            reqGetDictionaryListByCode(para).then((res)=>{
                                var dictionarys=res.data.data;
                                dictionarys.forEach(function (obj,i) {
                                    if(that.viewForm.department==obj.id){
                                        that.viewForm.department=obj.name;
                                    }
                                })
                            })
                        }
                        if(this.viewForm.education){
                          var that=this;
                          let para={code:'education'};
                          reqGetDictionaryListByCode(para).then((res)=>{
                            var dictionarys=res.data.data;
                            dictionarys.forEach(function (obj,i) {
                              if(that.viewForm.education==obj.id){
                                that.viewForm.education=obj.name;
                              }
                            })
                          })
                        }
                    }
                });
            },
                //修改页面通过id查询
                getPersonalInformationEditById() {
                    this.dialogFormVisible = true;
                    var id = window.sessionStorage.getItem('Authorization');
                    reqWebUserOne({id: id}).then((res) => {
                        if (res.data.code === 1) {
                            this.editForm.username = res.data.data.username;
                            this.editForm.sex = res.data.data.sex;
                            this.editForm.age = res.data.data.age;
                            this.editForm.education = res.data.data.education;
                            this.editForm.phoneNumber = res.data.data.phoneNumber;
                            this.editForm.email = res.data.data.email;
                            this.getDictionarys();
                        }
                    });
                },

            //修改个人信息
            personalInformationEdit(){
              this.$refs.editForm.validate((valid) => {
                if (valid) {
                var that = this;
                var id=window.sessionStorage.getItem('Authorization');
                  this.editForm.id=id;
                  let param={
                    id:this.editForm.id,
                    username:this.editForm.username,
                    sex:this.editForm.sex,
                    age: this.editForm.age,
                    education:this.editForm.education,
                    phoneNumber:this.editForm.phoneNumber,
                    email:this.editForm.email,
                  };
                  reqWebUserEdit(param).then((res) => {
                    if (res.data.code === 1) {
                      that.$message({
                        message: '修改成功',
                        type: 'success'
                      });
                      this.getPersonalInformation();
                      this.dialogFormVisible=false;
                    }else if(res.data.code===3){
                      that.$message({
                        message: '昵称已被注册，请重新输入',
                        type: 'error'
                      });
                      this.editForm.username='';
                    }else if(res.data.code===2){
                      that.$message({
                        message: '修改成功',
                        type: 'success'
                      });
                      this.getPersonalInformation();
                      this.dialogFormVisible=false;
                      sessionStorage.setItem('Authorization', res.data.data.token);
                      this.$store.dispatch('user_login',res.data.data.userName);
                    } else {
                      that.$message({
                        message: '该手机号已被占用，请重新输入',
                        type: 'error'
                      });
                      this.editForm.phoneNumber='';
                    }
                  })
                } else {
                  console.log('error submit!!');
                  return false;
                }
              });
            },
            getDictionarys(){
                reqGetDictionaryListByCode({code: 'education'}).then((res) => {
                    this.educationArray = res.data.data;
                })
            },
            getQuickMark() {
                if (this.viewForm.type==1) {
                    var imgName = this.viewForm.quickMark;
                    document.getElementById("quickMark").src = downloadFileURL + imgName + '/'
                }
            }

        },
        mounted(){
            this.$store.dispatch('showHF');
            this.getPersonalInformation();
            setTimeout(_ => {
//                this.getQuickMark();

            },300)
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/userCenter/PersonalInformation.vue